import React from 'react';
import { adminRoute } from '@/modules/administration/routes';
import { createRoute } from '@tanstack/react-router';

export const userManagementRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: 'user-management',
  wrapInSuspense: true,
  component: React.lazy(async () => await import('@/app/routes/Admin/Users')),
});
